import { isEmpty } from 'lodash/lang';
import { useCallback, useState } from 'react';

const useOpenClose = (initialValue = false) => {
  const [openArgs, setOpenArgs] = useState(initialValue ? { isOpen: true } : {});
  const close = useCallback(() => {
    setOpenArgs({});
  }, []);
  const open = useCallback((args = { isOpen: true }) => {
    setOpenArgs(args);
  }, []);
  const isOpen = !isEmpty(openArgs);
  return [isOpen, open, close, openArgs];
};

export default useOpenClose;
